<template>
  <div class="subtitles">
    {{ text }}
    <!-- <span
      v-for="(s, i) of words"
      :key="i">{{ s }}</span> -->
  </div>
</template>
<script>
export default {
  name: 'Subtitles',
  props: {
    text: {
      type: String,
      default: ''
    }
  } // ,
  // computed: {
  //   words () {
  //     return this.text.split(' ')
  //   }
  // }
}
</script>

<style lang="scss">
.subtitles {
  display: inline-block;
  text-align: left;
  color: white;
  font-weight: bold;
  text-shadow: rgba(black, .85) 1px 1px 3px;
  background: rgba(black, .25);
  font-size: 14px;
  padding: 4px 10px 8px;
  border-radius: 10px;
  // span {
  //   display: inline-block;
  //   padding: 0 2px 2px;
  //   margin-bottom: 5px;
  //   background: rgba(black, .25);
  //   line-height: 18px;
  // }
}
</style>
